<template>
	<div class="bordered-image background-cover" :style="styleObj"  :class="{ 'bordered-image--wide': isBorderWide }">
		<div class="bordered-image-border" :style="{ 'background-color': stripeColor }">
		</div>
	</div>
</template>

<script>
export default {
	props: {
		url: {
			type: String,
			default: '/images/asset-management-img.jpg'
		},
		stripeColor: {
			type: String,
			default: "rgba(23, 85, 131)"
		},
		isBorderWide: {
			 type: Boolean,
			 default: false
		}
	},
	computed: {
		styleObj() {
			return { 
				'background-image': 'url(' + encodeURI(this.url) + ')', 

				width: '100%', 
				height: '100%'
			}
		}
	}
}
</script>

<style lang="scss">
	.bordered-image {
		position: relative;
	}

	// default to orange..
	.article-detail-page .article-header-big .bordered-image-border {
		background-color: rgb(198, 84, 19);
	}

	.bordered-image-border {
		background-color: rgba(23, 85, 131);
		width: 40px;
		height: 100%;
		position: absolute;
		right: 0;
		opacity: 85%;

		// &.bordered-image-border--none {
		// 	background-color: transparent;
		// }

		&.bordered-image-border--orange {
			background-color: rgb(198, 84, 19) !important;
		}

		&.bordered-image-border--blue {
			background-color: rgba(23, 85, 131) !important;
		}
	}

	.bordered-image--wide {
		.bordered-image-border {
			width: 80px;
		}
	}

</style>
